import React, { useContext } from 'react'
import { Box, Link, Stack, Typography } from '@mui/material'
import TextInput from '../../../../../components/form/TextInput'
import { ameliUrl, BENEFICIARY_PREAFF_FIELDS, BOOLEAN, BOOLEANS, CIVILITES, SEXES } from '../../services/preaffiliationConstants'
import SelectInput from '../../../../../components/form/SelectInput'
import DatePickerInput from '../../../../../components/form/DatePickerInput'
import { FormattedMessage, useIntl } from 'react-intl'
import {
    BENEFICIARY_TYPES,
    BENEFICIARY_TYPES_WITHOUT_CONCUBIN,
    CONCUBIN_VALUE,
    CONJOINT_VALUE,
    ENFANT_MAJEUR,
    ENFANT_MINEUR,
    PACSES_VALUE
} from '../../../../../components/beneficiaryConstants'
import FileInput from '../../../../../components/fileInput/FileInput'
import RadioInput from '../../../../../components/form/RadioInput'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import ButtonLink from '../../../../../components/ButtonLink'
import Icon from '@mdi/react'
import { mdiAccountMinus, mdiAccountPlus } from '@mdi/js'
import { useBreakpoints } from '../../../../../components/breakpoints/BreakpointsProvider'
import { getTypeCouvertureFromTypeBeneficiaire } from '../../constants/global'
import { connect } from 'react-redux'
import { getMapCouvertures } from '../../../webservices/WsSelector'
import { toUpperCase } from '../../../../../utils/stringUtils'
import NissTextInput from '../../../../../components/NissTextInput'
import { ToastType } from '../../../../../components/toast/toastConstants'
import { ToastContext } from '../../../../../components/toast/ToastContext'


type BeneficiaireAffiliationFormProps = {
    selectedCouvertureAd: any
    values: any
    name: string
    index: number
    push: any
    fields: any
    key?: any
    coveragesBenefsMap: any
    listNumgar: string[]
    contract: any
}

const BeneficiaireAffiliationForm: React.FC<BeneficiaireAffiliationFormProps> = (
    {
        selectedCouvertureAd,
        values,
        name,
        index,
        fields,
        push,
        coveragesBenefsMap,
        listNumgar,
        contract
    }
) => {
    const intl = useIntl()
    const { isMobile, isTabletPortrait } = useBreakpoints()
    const { addToast } = useContext(ToastContext)
    const isMobOrTabVert = isMobile || isTabletPortrait

    const formBeneficiaryExists = (values: any, index: number): string => {
        if (values[BENEFICIARY_PREAFF_FIELDS.NAME] && values[BENEFICIARY_PREAFF_FIELDS.NAME][index]) {
            return values[BENEFICIARY_PREAFF_FIELDS.NAME][index][BENEFICIARY_PREAFF_FIELDS.TYPES]
        } else {
            return ""
        }
    }

    const couverturesBenefSelected = (values: any, index: number) => {
        if (coveragesBenefsMap && formBeneficiaryExists(values, index)) {
            const typeCode = formBeneficiaryExists(values, index)
            /*
             si offreAdherent != 0
                offreAdherent = offre BenefMap
             si offre == 0
                toutes
                a condition que nbBeneMax sur cette cover pas dépassée
             */
            if(selectedCouvertureAd !== undefined && selectedCouvertureAd.offre !== 'O'){
                return coveragesBenefsMap.get(getTypeCouvertureFromTypeBeneficiaire(typeCode)).filter((couverture: any) => couverture.offre === selectedCouvertureAd.offre)
            } else {
                const listCouverture: any[] = []
                coveragesBenefsMap.get(getTypeCouvertureFromTypeBeneficiaire(typeCode)).forEach((couverture :any) => {
                    let nbBenfCouverture = 0
                    values[BENEFICIARY_PREAFF_FIELDS.NAME].foreach((benef: any) => {
                        if(benef[BENEFICIARY_PREAFF_FIELDS.COVERAGE] === couverture.numFor){
                            nbBenfCouverture++
                        }
                    })
                    if(nbBenfCouverture < couverture.nbBeneMax){
                        listCouverture.push(couverture)
                    }
                })
                return listCouverture
            }
        } else {
            return [{value:"", libelle:"Sélectionnez un type de bénéficiaire"}]
        }
    }

    const getTypeBenef = (values: any, indexActuel: number) => {
        if (values[BENEFICIARY_PREAFF_FIELDS.NAME]) {
           let indexConjoint = undefined
            values[BENEFICIARY_PREAFF_FIELDS.NAME].forEach((typeValue: any, index: number) => {
                if(typeValue !== undefined && (typeValue.type === CONJOINT_VALUE
                    || typeValue.type === CONCUBIN_VALUE
                    || typeValue.type === PACSES_VALUE)){
                    indexConjoint = index
                }
            })
            if(indexConjoint !== undefined && indexActuel !== indexConjoint){
                return BENEFICIARY_TYPES_WITHOUT_CONCUBIN.map((type: any) => ({value: type.value, label: type.label}))
            } else {
                return BENEFICIARY_TYPES.map((type: any) => ({value: type.value, label: type.label}))
            }
        } else {
            return BENEFICIARY_TYPES.map((type: any) => ({value: type.value, label: type.label}))
        }
    }

    return (

        <Stack key={`${name}-${index}`} direction="column" spacing="32px">

            <Stack
                direction={isMobOrTabVert ? 'column' : 'row'}
                spacing={isMobOrTabVert ? '32px' : '42px'}
                flex="1"
            >
                <SelectInput
                    name={`${name}.${BENEFICIARY_PREAFF_FIELDS.TYPES}`}
                    label={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.type.label'})}
                    data={getTypeBenef(values, index)}
                    mandatory
                />
                <SelectInput
                    name={`${name}.${BENEFICIARY_PREAFF_FIELDS.COVERAGE}`}
                    label={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.coverage.label'})}
                    defaultValue={couverturesBenefSelected(values, index).length === 1 ? couverturesBenefSelected(values, index)[0].numFor : undefined}
                    data={couverturesBenefSelected(values, index).map((couverture: any) => ({value: couverture.numFor, label: couverture.libelle}))}
                    mandatory
                />
            </Stack>

            <Stack
                direction={isMobOrTabVert ? 'column' : 'row'}
                spacing={isMobOrTabVert ? '32px' : '42px'}
                flex="1"
            >
                <SelectInput
                    name={`${name}.${BENEFICIARY_PREAFF_FIELDS.CIVILITY}`}
                    label={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.civility.label'})}
                    data={CIVILITES.map((civilite: any) => ({value: civilite.value, label: civilite.label}))}
                    mandatory
                />
                <SelectInput
                    name={`${name}.${BENEFICIARY_PREAFF_FIELDS.SEX}`}
                    label={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.sex.label'})}
                    data={SEXES.map((sexe: any) => ({value: sexe.value, label: sexe.label}))}
                    mandatory
                />
            </Stack>

            <Stack
                direction={isMobOrTabVert ? 'column' : 'row'}
                spacing={isMobOrTabVert ? '32px' : '42px'}
                flex="1"
            >
                <TextInput
                    name={`${name}.${BENEFICIARY_PREAFF_FIELDS.LAST_NAME}`}
                    label={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.lastName.label'})}
                    placeholder={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.lastName.placeholder'})}
                    maxLength={30}
                    maxWidth="unset"
                    mandatory={true}
                    format={toUpperCase}
                />
                <TextInput
                    name={`${name}.${BENEFICIARY_PREAFF_FIELDS.FIRSTNAME}`}
                    label={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.firstName.label'})}
                    placeholder={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.firstName.placeholder'})}
                    maxLength={30}
                    maxWidth="unset"
                    mandatory={true}
                    format={toUpperCase}
                />
            </Stack>

            <Stack direction="column" spacing="32px" flex="1">
                <Stack
                    direction={isMobOrTabVert ? 'column' : 'row'}
                    spacing={isMobOrTabVert ? '32px' : '42px'}
                    flex="1"
                >
                    {formBeneficiaryExists(values, index) !== ENFANT_MINEUR
                        ? (
                            <NissTextInput
                                name={`${name}.${BENEFICIARY_PREAFF_FIELDS.NISS}`}
                                label={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.NSS.label'})}
                                placeholder={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.NSS.placeholder'})}
                                helperText={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.NSS.info'})}
                                format={toUpperCase}
                                maxWidth="unset"
                                mandatory
                            />
                        ) : undefined
                    }
                    <DatePickerInput
                        name={`${name}.${BENEFICIARY_PREAFF_FIELDS.BIRTH_DATE}`}
                        label={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.birthDate.label'})}
                        maxWidth="unset"
                        mandatory={true}
                    />
                    {formBeneficiaryExists(values, index) === ENFANT_MINEUR && !isMobOrTabVert
                        ? <Box maxWidth="600px" width="100%"/> : undefined
                    }
                </Stack>

                {formBeneficiaryExists(values, index) === ENFANT_MINEUR
                    ? (
                        <Stack direction="column" spacing="12px">
                            <Stack direction="row" spacing="8px">
                                <InfoOutlinedIcon width="400px"/>
                                <Typography variant="body2" fontSize="0.875rem">
                                    <FormattedMessage id="preaffiliation.cntrtAndBenef.beneficiary.form.NSS.warning"/>
                                </Typography>
                            </Stack>

                            <Stack
                                direction={isMobOrTabVert ? 'column' : 'row'}
                                spacing={isMobOrTabVert ? '32px' : '42px'}
                                flex="1"
                            >
                                <NissTextInput
                                    name={`${name}.${BENEFICIARY_PREAFF_FIELDS.NISS}`}
                                    label={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.NSS.label'})}
                                    placeholder={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.NSS.placeholder'})}
                                    format={toUpperCase}
                                    maxWidth="unset"
                                    mandatory
                                />
                                <NissTextInput
                                    name={`${name}.${BENEFICIARY_PREAFF_FIELDS.NISS_PARENT}`}
                                    label={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.NSS.label2'})}
                                    placeholder={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.NSS.placeholder'})}
                                    helperText={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.NSS.info2'})}
                                    format={toUpperCase}
                                    maxWidth="unset"
                                />
                            </Stack>
                        </Stack>
                    ) : undefined
                }

            </Stack>

            <Stack direction="column" spacing="24px">
                <FileInput
                    required
                    name={`${name}.${BENEFICIARY_PREAFF_FIELDS.NISS_ATTESTATION}`}
                    title={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.attestation.title'})}
                    maxFileNumber={1}
                    label={
                        <Stack
                            direction={isMobOrTabVert ? 'column' : 'row'}
                            spacing={isMobOrTabVert ? '4px' : undefined}
                            justifyContent="space-between"
                        >
                            <Typography variant="body2" fontSize="0.875rem">
                                <FormattedMessage id="preaffiliation.cntrtAndBenef.beneficiary.form.attestation.label"/>
                            </Typography>

                            <Typography variant="body2" fontSize="0.75rem">
                                <Link
                                    href={ameliUrl}
                                    underline="none"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                    sx={(theme) => ({color: theme.palette.secondary.main})}
                                >
                                    {intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.attestation.link'})}
                                </Link>
                            </Typography>
                        </Stack>
                    }
                />

                {(formBeneficiaryExists(values, index) === ENFANT_MAJEUR
                        || formBeneficiaryExists(values, index) === CONCUBIN_VALUE
                        || formBeneficiaryExists(values, index) === PACSES_VALUE)
                    && (
                        <FileInput
                            required
                            name={`${name}.${BENEFICIARY_PREAFF_FIELDS.FILES}`}
                            maxFileNumber={1}
                            title={
                                <Typography fontWeight="500" fontSize="0.875rem" whiteSpace="pre-line">
                                    {intl.formatMessage({
                                        id: (formBeneficiaryExists(values, index) === ENFANT_MAJEUR)
                                            ? 'preaffiliation.cntrtAndBenef.beneficiary.form.files.title_2_B'
                                            : formBeneficiaryExists(values, index) === CONCUBIN_VALUE
                                                ? 'preaffiliation.cntrtAndBenef.beneficiary.form.files.title_3'
                                                : 'preaffiliation.cntrtAndBenef.beneficiary.form.files.title_7'
                                    })}
                                </Typography>
                            }
                            label={intl.formatMessage({
                                id: (formBeneficiaryExists(values, index) === ENFANT_MAJEUR)
                                    ? 'preaffiliation.cntrtAndBenef.beneficiary.form.files.label_2_B'
                                    : formBeneficiaryExists(values, index) === CONCUBIN_VALUE
                                        ? 'preaffiliation.cntrtAndBenef.beneficiary.form.files.label_3'
                                        : 'preaffiliation.cntrtAndBenef.beneficiary.form.files.label_7'
                            })}

                    />
                    )
                }

                {((formBeneficiaryExists(values, index) === CONJOINT_VALUE
                        || formBeneficiaryExists(values, index) === CONCUBIN_VALUE
                        || formBeneficiaryExists(values, index) === PACSES_VALUE)
                    && (contract && listNumgar.includes(contract.numgar)))
                    && (
                        <FileInput
                            name={`${name}.${BENEFICIARY_PREAFF_FIELDS.FILES_CONJOINT}`}
                            maxFileNumber={1}
                            title={
                                <Typography fontWeight="500" fontSize="0.875rem" whiteSpace="pre-line">
                                    {intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.files.title_conjoint'})}
                                </Typography>
                            }
                            label={intl.formatMessage({
                                id: 'preaffiliation.cntrtAndBenef.beneficiary.form.files.label_conjoint'
                            })}
                        />
                    )
                }

                <Stack direction="column" spacing="12px">
                    <RadioInput
                        name={`${name}.${BENEFICIARY_PREAFF_FIELDS.TELETRANSMISSION}`}
                        label={intl.formatMessage({id: 'preaffiliation.cntrtAndBenef.beneficiary.form.teletransmission.label'})}
                        data={BOOLEANS.map((boolean: any) => ({value: boolean.value, label: boolean.label}))}
                        direction="row"
                        defaultValue={formBeneficiaryExists(values, index) === ENFANT_MINEUR || formBeneficiaryExists(values, index) === ENFANT_MAJEUR
                            ? BOOLEAN.OUI.value : BOOLEAN.NON.value
                        }
                        radioSpacing="24px"
                    />
                    <Stack direction="row" spacing="8px">
                        <InfoOutlinedIcon width="400px"/>
                        <Typography variant="body2" fontSize="0.875rem">
                            <FormattedMessage id="preaffiliation.personalInfos.form.teletransmission.helper"/>
                        </Typography>
                    </Stack>
                </Stack>

                <Stack direction="row" justifyContent="center">
                    <Stack direction="column" textAlign="center">
                        {fields.value.length > 1 &&
                            <Box flex="1">
                                <ButtonLink
                                    variant="contained"
                                    startIcon={<Icon size="20px" path={mdiAccountMinus}/>}
                                    onClick={() => {
                                        fields.remove(index)
                                    }}
                                    sx={{textAlign: 'center', lineHeight: '18px'}}
                                >
                                    <FormattedMessage id="preaffiliation.cntrtAndBenef.beneficiary.delete"/>
                                </ButtonLink>
                            </Box>
                        }

                        { (index === fields.value.length - 1 && values[BENEFICIARY_PREAFF_FIELDS.NAME] && values[BENEFICIARY_PREAFF_FIELDS.NAME][index] && values[BENEFICIARY_PREAFF_FIELDS.NAME][index] && values[BENEFICIARY_PREAFF_FIELDS.NAME][index][BENEFICIARY_PREAFF_FIELDS.COVERAGE] !== undefined) &&
                            <Box flex="1">
                                <ButtonLink
                                    variant="contained"
                                    startIcon={<Icon size="20px" path={mdiAccountPlus}/>}
                                    onClick={() => {
                                        if(selectedCouvertureAd !== undefined
                                            && selectedCouvertureAd.offre !== 0
                                            && selectedCouvertureAd.nbBeneMax !== undefined
                                            && selectedCouvertureAd.nbBeneMax >= values[BENEFICIARY_PREAFF_FIELDS.NAME].length) {
                                            addToast(ToastType.INFO, "preaffiliation.cntrtAndBenef.beneficiary.addNoMore")
                                        } else if(selectedCouvertureAd !== undefined
                                            && selectedCouvertureAd.offre !== 0
                                            && couverturesBenefSelected(values, index).length === 0) {
                                            addToast(ToastType.INFO, "preaffiliation.cntrtAndBenef.beneficiary.addNoMore")
                                        } else {
                                            push(fields.name, undefined)
                                        }
                                    }}
                                    sx={{textAlign: 'center', lineHeight: '18px'}}
                                >
                                    <FormattedMessage id="preaffiliation.cntrtAndBenef.beneficiary.addmore"/>
                                </ButtonLink>
                            </Box>
                        }
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}

const mapStateToProps = () => {

    return (state: any) => ({
        coveragesBenefsMap: state.pages && getMapCouvertures(state)
    })
}

export default connect(mapStateToProps)(BeneficiaireAffiliationForm)

